// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLinks__socialLink__kIHj3","socialLink__Icon":"SocialLinks__socialLink__Icon__rkGL8"};